export const rtspDefaults = Object.freeze({ path: "", format: "mpegts", username: "", password: "", hasPassword: false, clearCredentials: false });
export function normalizeRTSP(value) { return { ...rtspDefaults, ...(value && typeof value === "object" ? value : {}) }; }
export function validateRTSP(value) {
 const c = normalizeRTSP(value);
 if (c.path && !/^\/?[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*\/?$/.test(c.path)) return "Use letters, digits, hyphens, underscores, and slashes in the path";
 if (!["mpegts", "tracks"].includes(c.format)) return "Select a delivery format";
 if (!c.clearCredentials && Boolean(c.username) !== Boolean(c.password || c.hasPassword)) return "Enter both a username and a password";
 return "";
}
export function rtspPayload(value) {
 const c = normalizeRTSP(value);
 return { path: c.path.trim(), format: c.format, username: c.username, ...(c.password ? { password: c.password } : {}), ...(c.clearCredentials ? { clearCredentials: true } : {}) };
}
export function rtspViewerURL(raw, browserHost) {
 if (!raw) return "";
 try {
  const u = new URL(raw);
  if (u.protocol !== "rtsp:") return "";
  u.username = "";
  u.password = "";
  // Wails hosts the desktop UI on a synthetic origin that external players
  // cannot resolve. Keep the server's localhost fallback in that shell.
  if (u.hostname === "localhost" && browserHost && browserHost.toLowerCase() !== "wails.localhost") u.hostname = browserHost;
  return u.toString();
 } catch { return ""; }
}

export function rtspTargetURL(path, baseURL, browserHost) {
 const mount = String(path || "").trim().replace(/\/+$/, "");
 const base = rtspViewerURL(baseURL, browserHost);
 if (!mount || !base || !/^\/?[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_-]+)*$/.test(mount)) return "";
 const url = new URL(base);
 url.pathname = mount.startsWith("/") ? mount : `/${mount}`;
 return url.toString();
}

export function clearRTSPConfig(config) { const result = { ...config }; for (const key of ["path", "format", "username", "password", "hasPassword", "clearCredentials"]) delete result[key]; return result; }
